import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectSemesterYear {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectSemesterYear = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectSemesterYear) => {
  const itemList = useStoreState((state) => state.common.sessionYearList);
  const itemListFetch = useStoreActions((state) => state.common.fetchsessionYearList);
  //const thanaListFetch = useStoreActions((state) => state.common.thanaListFetch);
  if (itemList === null) {
    itemListFetch();
  }
  
  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.id === id);
      onChange(value.id);
    }
  };

  // React.useEffect(() => {
  //   if (selected) {
  //     thanaListFetch(selected?.districtId);
  //   }
  // }, [selected])


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      placeholder="Select Semester Year"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.id} value={type.id}>
            {type.name}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Semester Year</Option>
      )}
    </Select>
  );
};
